/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgJira = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 0h20v20H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M17.372 1.875H9.619c0 1.872 1.569 3.395 3.495 3.395h1.434v1.327c0 1.872 1.569 3.395 3.496 3.395V2.528a.65.65 0 0 0-.672-.653Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.54 5.618H5.788c0 1.872 1.568 3.395 3.495 3.395h1.434v1.35c0 1.87 1.569 3.394 3.495 3.394V6.271a.665.665 0 0 0-.672-.653Z",
        fill: "url(#Jira_svg__a)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.709 9.383H1.956c0 1.871 1.569 3.395 3.496 3.395h1.434v1.327c0 1.872 1.568 3.395 3.495 3.395v-7.464a.665.665 0 0 0-.672-.653Z",
        fill: "url(#Jira_svg__b)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "Jira_svg__a",
        x1: 14.047,
        y1: 5.637,
        x2: 10.85,
        y2: 9.031,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.176,
        stopColor: "#0052CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#2684FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "Jira_svg__b",
        x1: 10.431,
        y1: 9.408,
        x2: 6.729,
        y2: 13.117,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.176,
        stopColor: "#0052CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#2684FF"
    }))));
export default SvgJira;
